import { useLoadingStore } from '@/shared/model';
import { useEffect } from 'react';

/**
 * Wires the diagnostic yield page to the global loading indicator. Reads setLoadingText from the loading store and invokes it once on mount.
 *
 * @returns Nothing.
 */
const useDiagnosticYield = () => {
  /**
   * Holds the store action that sets the global page loading text. Read from the loading store's setLoadingText field.
   *
   * @returns The setLoadingText action.
   */
  const loadingPageAction = useLoadingStore((s) => s.setLoadingText);

  useEffect(() => {
    loadingPageAction();
  }, []);
};

export { useDiagnosticYield };
